import { render } from "./Robots.vue?vue&type=template&id=99e5cbd2&ts=true"
import script from "./Robots.vue?vue&type=script&lang=ts"
export * from "./Robots.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/thomasplanckaert/Dedalus/GIT/carteconfituur/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__